<template>
  <section class="userWx">
    <el-dialog
      title="清单上传"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="750px"
      @close="dialogVisible=false"
    >
      <div class="userWx-content">
        <div>
          <span>学科分类：</span>
          <el-cascader
            v-model="categorys"
            :options="subjects"
            clearable
            @change="handleChange"
          />
        </div>

        <el-upload
          class="upload"
          action="/"
          :http-request="httpRequest"
          :limit="1"
          :on-change="onChange"
          :before-upload="beforeUpload"
          :on-remove="onRemove"
          accept=".xls,.xlsx"
          :file-list="fileList">
          <el-button
            size="small"
            type="primary"
            :disabled="fileList.length!==0">
            点击上传
          </el-button>
          <div slot="tip" class="el-upload__tip">
            请选择上传的xlsx文件或xls文件
          </div>
        </el-upload>
      </div>
      <div slot="footer" class="userWx-foot">
        <el-button @click="cancelSubmit">
          取 消
        </el-button>
        <el-button type="primary" @click="handleSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
// import { getToken } from "@/utils/auth";
// import axios from "axios";

import api from '@/api/app'
export default {
  name: 'ComList',
  components: {},
  props: {
    subjects: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dialogVisible: true,
      loading: false,
      ids: 0,
      category_id: 0,
      tips: '只能上传 zip 文件，且不超过8M',
      categorys: [],
      // * upload
      upload: {
        autoUpload: false,
        action: '',
        accept: ''
      },
      formData: null,
      fileList: [],
      fileValue: null
    }
  },
  computed: {},
  watch: {
    dialogVisible: {
      handler(val) {
        if (!val) {
          this.cancelSubmit(1)
        }
      }
    }
  },
  mounted() {},
  methods: {
    init(v) {},
    handleChange(v) {
      this.category_id = v[1]
    },
    onChange(file) {
      this.fileValue = file.raw
    },
    onRemove() {
      this.fileValue = null
    },
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const arr = ['xls', 'xlsx']
      if (!arr.includes(testmsg)) {
        this.$message.error('上传文件格式错误')
        return false
      }
      return true
    },
    httpRequest() {

    },
    handleSubmit() {
      if (this.fileValue && (this.category_id || this.category_id === 0)) {
        const data = new FormData()
        data.append('file', this.fileValue)
        data.append('category_id', this.category_id)
        api.proList.update.upload(data).then((res) => {
          this.$message({
            message: '清单导入成功',
            type: 'success'
          })
        })
        this.formData = null
        this.categorys = []
        this.dialogVisible = false
      } else {
        this.$message.error('请补充完整信息')
      }
    },
    cancelSubmit: function() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped >
.userWx {
  &-content {
    height: 100%;
    // text-align: center;
    padding: 10px 0;
    // display: flex;
    // > div {
    //   &:nth-child(2) {
    //     margin-left: 20px;
    //   }
    // }
  }
}
.upload{
  width: 360px;
  margin-top: 20px;
  /deep/ .el-upload--text{
    display: block;
    width: 80px;
  }
}
</style>

